/**************************************************************************************************/
/*   File: /src/app/shared/enums/message.position.enum.ts                                         */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Tuesday February 19th 2019                                                     */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Feb 22 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
/**
 * The message position
 */
export enum MessagePositionEnum {
    /**
     * Popup position
     */
    POPUP = 'Popup',
    /**
     * Top position
     */
    TOP = 'Top'
}